import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';

// With react-router-dom@^6.0.0 use `ref` instead of `innerRef`
// See https://github.com/ReactTraining/react-router/issues/6056
const CollisionLink = (link = '/') =>
  forwardRef((props, ref) => <Link innerRef={ref} to={link} {...props} />);
export default CollisionLink;
